import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  ChevronRight,
  Calendar,
  Save,
  RotateCcw
} from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
// Consolidated CSS is imported globally'

const DropdownMasterEdit = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dropdownData = location.state?.rowData

  const [formData, setFormData] = useState({
    dropdownCategory: '',
    label: '',
    value: '',
    order: 1,
    status: 'Active',
    createdDate: '24-09-2025'
  })

  useEffect(() => {
    if (dropdownData) {
      setFormData({
        dropdownCategory: dropdownData.dropdownCategory || '',
        label: dropdownData.label || '',
        value: dropdownData.value || '',
        order: dropdownData.order || 1,
        status: dropdownData.status || 'Active',
        createdDate: dropdownData.createdDate || '24-09-2025'
      })
    }
  }, [dropdownData])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSave = () => {
    console.log('Updating Dropdown Master data:', formData)
    navigate('/settings/dropdown-master')
  }

  const handleReset = () => {
    if (dropdownData) {
      setFormData({
        dropdownCategory: dropdownData.dropdownCategory || '',
        label: dropdownData.label || '',
        value: dropdownData.value || '',
        order: dropdownData.order || 1,
        status: dropdownData.status || 'Active',
        createdDate: dropdownData.createdDate || '24-09-2025'
      })
    }
  }

  const handleBack = () => {
    navigate('/settings/dropdown-master')
  }

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Breadcrumb Navigation */}
        <div className="breadcrumb-section">
          <nav className="breadcrumb-nav">
            <button className="breadcrumb-item" onClick={() => navigate('/settings')}>
              <span>Settings</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <button className="breadcrumb-item" onClick={() => navigate('/settings?tab=masters')}>
              <span>Masters</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <span className="breadcrumb-current">Dropdown Master</span>
          </nav>
        </div>

        {/* Header Section */}
        <div className="page-header">
          <div className="header-left">
            <button className="back-btn" onClick={handleBack}>
              <ArrowLeft size={20} />
            </button>
            <div className="page-title">
              <h1>Dropdown Master</h1>
              <p>Manage dropdown options and lists used across the application</p>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="card">
          <div className="form-header-dark">
            <h2>Edit Dropdown Master</h2>
          </div>
          <div className="card-body">
            <form className="form-content">
              <div className="grid-row-3">
                <div className="form-group">
                  <label htmlFor="dropdownCategory" className="form-label required">
                    Dropdown Category
                  </label>
                  <input
                    type="text"
                    id="dropdownCategory"
                    name="dropdownCategory"
                    value={formData.dropdownCategory}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter dropdown category (e.g., Status, Priority)"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="label" className="form-label required">
                    Label
                  </label>
                  <input
                    type="text"
                    id="label"
                    name="label"
                    value={formData.label}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter display label (e.g., Active, High Priority)"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="value" className="form-label required">
                    Value
                  </label>
                  <input
                    type="text"
                    id="value"
                    name="value"
                    value={formData.value}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter value (e.g., active, high)"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="order" className="form-label required">
                    Order
                  </label>
                  <input
                    type="number"
                    id="order"
                    name="order"
                    value={formData.order}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter display order"
                    min="1"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="status" className="form-label required">
                    Status
                  </label>
                  <select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="createdDate" className="form-label required">
                    Created Date
                  </label>
                  <div className="date-input-wrapper">
                    <input
                      type="date"
                      id="createdDate"
                      name="createdDate"
                      value={formData.createdDate}
                      onChange={handleInputChange}
                      className="form-input date-input"
                    />
                    <Calendar size={16} className="calendar-icon" />
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="form-actions">
                <button
                  type="button"
                  onClick={handleReset}
                  className="btn-secondary"
                >
                  <RotateCcw size={16} />
                  Reset
                </button>
                <button
                  type="button"
                  onClick={handleSave}
                  className="btn-primary"
                >
                  <Save size={16} />
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownMasterEdit
